import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface AttendanceNotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  attendeeName: string;
  notes: string | null;
  onSave?: (notes: string) => void;
  isLoading?: boolean;
}

function AttendanceNotesModal({
  isOpen,
  onClose,
  attendeeName,
  notes,
  onSave,
  isLoading = false,
}: AttendanceNotesModalProps) {
  const [notesValue, setNotesValue] = useState(notes || "");

  useEffect(() => {
    setNotesValue(notes || "");
  }, [notes]);

  const handleSave = () => {
    if (!onSave) {
      onClose();
      return;
    }

    onSave(notesValue);
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Attendance Notes - {attendeeName}</DialogTitle>
        </DialogHeader>

        <div>
          <Textarea
            className="w-full min-h-[120px]"
            disabled={isLoading}
            onChange={(e) => setNotesValue(e.target.value)}
            placeholder="Enter notes about this attendee's attendance status..."
            value={notesValue}
          />
        </div>

        <DialogFooter>
          <Button disabled={isLoading} onClick={onClose} variant="outline">
            Cancel
          </Button>
          <Button disabled={isLoading} onClick={handleSave}>
            {isLoading ? "Saving..." : "Save Notes"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default AttendanceNotesModal;
